import { useTranslation } from "react-i18next";
import Layout from "@/components/Layout";
import TutorialCard from "@/components/TutorialCard";
import type { TutorialLevel } from "@/components/TutorialCard";

const Tutorials = () => {
  const { t } = useTranslation();

  const tutorials = [
    {
      title: t('tutorialsPage.tutorial1'),
      src: "https://www.youtube.com/watch?v=yr3GE47s3y8",
      time: "00:04:37",
      level: "beginner" as TutorialLevel,
    },
    {
      title: t('tutorialsPage.tutorial2'),
      src: "https://www.youtube.com/watch?v=A9rvliooAGc",
      time: "00:02:20",
      level: "beginner" as TutorialLevel,
    },
    {
      title: t('tutorialsPage.tutorial3'),
      src: "https://www.youtube.com/watch?v=JRpTrB-H9iY",
      time: "00:01:11",
      level: "beginner" as TutorialLevel,
    },
    {
      title: t('tutorialsPage.tutorial4'),
      src: "https://www.youtube.com/watch?v=sSIWj9INi20",
      time: "00:03:07",
      level: "beginner" as TutorialLevel,
    },
    {
      title: t('tutorialsPage.tutorial5'),
      src: "https://www.youtube.com/watch?v=SyVqlctcrAo",
      time: "00:03:55",
      level: "intermediate" as TutorialLevel,
    },
    {
      title: t('tutorialsPage.tutorial6'),
      src: "https://www.youtube.com/watch?v=4ltj10QakvU",
      time: "00:00:48",
      level: "beginner" as TutorialLevel,
    },
    {
      title: t('tutorialsPage.tutorial7'),
      src: "https://www.youtube.com/watch?v=hxOP9AhVoFY",
      time: "00:05:53",
      level: "intermediate" as TutorialLevel,
    },
    {
      title: t('tutorialsPage.tutorial8'),
      src: "https://www.youtube.com/watch?v=KKtRKpPVdWI",
      time: "00:03:21",
      level: "intermediate" as TutorialLevel,
    },
  ];

  return (
    <Layout>
      <div className="flex-1 p-4 lg:p-6">
        <div className="container mx-auto space-y-6">
          <div className="text-center space-y-2">
            <h1 className="text-3xl font-bold bg-gradient-primary bg-clip-text text-transparent">
              {t('tutorials.title')}
            </h1>
            <p className="text-muted-foreground">
              {t('tutorials.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {tutorials.map((tutorial) => (
              <TutorialCard key={tutorial.src} title={tutorial.title} src={tutorial.src} time={tutorial.time} level={tutorial.level} />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Tutorials;
